import styled from 'styled-components';
import { layout, media } from 'src/components/base';

export const RelatedResources = styled.div`
  display: flex;
  margin-bottom: ${layout.margins.component.desktop.rem};
  flex-wrap: wrap;

  ${media.mediumDown`
  margin-bottom: ${layout.margins.component.mobile.rem};
  `}

  > * {
    white-space: nowrap;
    margin-top: ${layout.measurements.spacing050};
    margin-right: ${layout.measurements.spacing050};
  }
`;
